<span *ngIf="escalationName">{{escalationName}}</span>
<span *ngIf="!escalationName">No escalation information</span>
